import React, { createContext, useContext } from 'react';

/**
 * Data of DREW's OE Dashboard, shared with its widgets (Beta-1 plan P3-20).
 *
 * The page (`DriftDashboard.jsx`) keeps every Firestore hook exactly as before and publishes
 * the results here; widgets only READ. That keeps the read budget unchanged (no widget opens
 * its own listener — the 17M-reads lesson) and keeps scope in one place: the layout never
 * changes the data scope (C0814).
 */
const OEDashboardContext = createContext(null);

export function OEDashboardProvider({ value, children }) {
  return <OEDashboardContext.Provider value={value}>{children}</OEDashboardContext.Provider>;
}

/** The dashboard data, or an empty shape when rendered outside the page (gallery previews). */
export function useOEDashboard() {
  return useContext(OEDashboardContext) || EMPTY;
}

const EMPTY = Object.freeze({
  organization: null,
  scope: null,
  thresholds: null,
  snapshots: [],
  latestSnapshot: null,
  latestScores: null,
  enrichedScores: null,
  elementScores: null,
  warningsByQuadrant: {},
  activeSurveys: [],
  surveys: [],
  responseCounts: {},
  caseStudies: [],
  caseStudiesLoading: false,
  conditions: [],
  allConditions: [],
  expandedQuadrant: null,
  onQuadrantClick: () => {},
  preview: true,
});

export default OEDashboardContext;
